export default __webpack_public_path__ + "assets/38319b3792aae296e1680d328cfb9e41.png";